import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { DsFormlyFieldType } from '@app/forms/formly/types/ds-formly-field';

@Component({
  selector: 'cc-expiration-field',
  templateUrl: './cc-expiration-field.component.html',
  styleUrls: ['./cc-expiration-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcExpirationFieldComponent extends DsFormlyFieldType implements OnInit {
  previousDigitCount = 0;

  override ngOnInit() {
    super.ngOnInit();
    this.previousDigitCount = String(this.formControl.value ?? '').replace(/\D/g, '').length;
  }

  onExpirationChange(value: string) {
    const digitCount = value.replace(/\D/g, '').length;

    if (digitCount === 4 && this.previousDigitCount < 4) {
      this.focusSecurityCode();
    }

    this.previousDigitCount = digitCount;
  }

  focusSecurityCode() {
    const selector = (this.props['nextFocusSelector'] as string | undefined) || '[data-id="cvv2"]';
    const root = this.hostElement.nativeElement.closest('form') ?? document;
    const host = root.querySelector(selector) as HTMLElement | null;
    const focusable =
      (host?.matches('input, select, textarea, button')
        ? host
        : (host?.querySelector('input, select, textarea, button') as HTMLElement | null)) || null;

    focusable?.focus();
  }
}
